import React from 'react';

import ArchivedJobProspectsLoader from './ArchivedJobProspectsLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import ArchivedJobProspectsTable from './ArchivedJobProspectsTable';
import ArchivedJobProspectsPageController from './ArchivedJobProspectsPageController';
import { useArchivedJobProspectsState } from './ArchivedJobProspectsContext';
import styles from './ArchivedJobProspects.module.scss';

const ArchivedJobProspectsContent = () => {
  const state = useArchivedJobProspectsState();

  if (state?.loading) {
    return (
      <div className={styles.pageLayout}>
        <p style={{ textAlign: 'center', fontWeight: 'bold' }}>Loading</p>
      </div>
    );
  }

  return (
    <div className={styles.pageLayout}>
      <Stack gap="lg">
        <PageTitle text={'Archived Job Prospects'} />
        <ArchivedJobProspectsPageController />
        <ArchivedJobProspectsTable />
        <ArchivedJobProspectsPageController />
      </Stack>
    </div>
  );
};

const ArchivedJobProspects = () => {
  return (
    <>
      <ArchivedJobProspectsLoader />
      <ArchivedJobProspectsContent />
    </>
  );
};

export default ArchivedJobProspects;
